module.exports = __webpack_public_path__ + "icomoon.a0486.ttf";


//////////////////
// WEBPACK FOOTER
// ./app/fonts/spinnaker/fonts/icomoon.ttf?jeuj5q
// module id = 2752
// module chunks = 0